// src/permissions.js
// Central role-based access control configuration.
// Add new roles here — do NOT scatter role checks across components.

export const ROLES = {
    CLIENT_ADMIN: 'ClientAdministrator',
    CLIENT_USER: 'ClientUser',
    CUSTOMER: 'Customer', // Future: self-service kiosk — Buscador only, no cart
};

// Routes each role is allowed to access.
// '*' = unrestricted. Any route not in the list → redirect to /Buscador.
// Print routes (/print-quote, /print-stickers, /print-ra, /print-po-supplier)
// are handled separately in App.js and are always allowed for authenticated users.
export const ROLE_ALLOWED_ROUTES = {
    [ROLES.CLIENT_ADMIN]: '*',

    [ROLES.CLIENT_USER]: [
        '/',
        '/home',
        '/Buscador',
        '/Invoices',
        '/FacturaEnCola',
        '/Presupuestos',
        '/NotasCredito',
        '/Clientes',
        '/CuentasCorrientes',
        '/CuentasAbiertas',
        '/manual',
        '/ClientDocumentation',
        '/UserManual',
    ],

    // Future role — only Buscador, no shopping cart
    [ROLES.CUSTOMER]: [
        '/',
        '/home',
        '/Buscador',
    ],
};

/**
 * Returns true if the given role may access the given route path.
 * @param {string} role  - e.g. 'ClientAdministrator'
 * @param {string} route - e.g. '/Dashboard'
 */
export const canAccess = (role, route) => {
    const allowed = ROLE_ALLOWED_ROUTES[role];
    if (!allowed) return false;
    if (allowed === '*') return true;
    return allowed.includes(route);
};

/**
 * Returns true if the role is ClientAdministrator (or legacy 'admin').
 * Use this for feature-level checks (e.g., hiding summary cards).
 * @param {string|undefined} role
 */
export const isAdminRole = (role) =>
    role === ROLES.CLIENT_ADMIN || role === 'admin';
